import { Textarea } from '../../../ui/Textarea';

interface IntentStepProps {
  value: string;
  onChange: (next: string) => void;
}

export function IntentStep({ value, onChange }: IntentStepProps) {
  return (
    <div className="refine-step refine-step--intent">
      <h3 className="refine-step__title">What would you like to change?</h3>
      <p className="refine-step__help">
        Describe the specific edit you want — e.g. "make the hat red", "add a
        small cat next to the character", "change the sky to sunset".
      </p>
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Describe the change..."
        rows={4}
        variant="ui"
        autoFocus
      />
    </div>
  );
}
